import { useDispatch, useSelector } from "react-redux";
import BookList from "../components/books/BookList";
import { tagSelected } from "../features/filter/filterSlice";

export default function BookStore() {
	const { tag } = useSelector(state => state.filter);
	const dispatch = useDispatch();

	const handleTagSelected = (selectedTag) => {
		dispatch(tagSelected(selectedTag));
	}

	return (
		<main className="py-12 px-6 2xl:px-6 container">
			<div className="order-2 xl:-order-1">
				<div className="flex items-center justify-between mb-12">
					<h4 className="mt-2 text-xl font-bold">Book List</h4>

					<div className="flex items-center space-x-4">
						<button
							onClick={() => handleTagSelected("All")}
							className={`lws-filter-btn ${tag==="All"?'active-filter':''}`}
						>
							All
						</button>
						<button 
							onClick={() => handleTagSelected("Featured")}
							className={`lws-filter-btn ${tag==="Featured"?'active-filter':''}`}
						>
							Featured
						</button>
					</div>
				</div>
				
                <BookList />
			</div>
		</main>
	);
}
